// tslint:disable: max-line-length
import * as React from "react";
import SvgIcon from "material-ui/SvgIcon";

export class AssortmentDownload extends React.PureComponent<any, any> {
    render() {
        return (
            <SvgIcon viewBox="0 0 24 24" {...this.props}>
                <path d="M15.3,18.3L13,20.6V6c0-0.6-0.4-1-1-1c-0.6,0-1,0.4-1,1v14.6l-2.3-2.3c-0.4-0.4-1-0.4-1.4,0c-0.4,0.4-0.4,1,0,1.4l4,4c0.2,0.2,0.4,0.3,0.7,0.3c0,0,0,0,0,0c0,0,0,0,0,0c0.3,0,0.6-0.1,0.8-0.4l3.9-3.9c0.4-0.4,0.4-1,0-1.4C16.3,17.9,15.7,17.9,15.3,18.3z" />
                <path d="M20.7,0.3C20.5,0.1,20.3,0,20,0H4C3.4,0,3,0.4,3,1v11c0,0.6,0.4,1,1,1h4c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1H5V2h14l0,9h-3c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h4c0.6,0,1-0.4,1-1l0-11C21,0.7,20.9,0.5,20.7,0.3z" />
            </SvgIcon>
        );
    }
}
